import { createInteractiveColorVar } from '../../helpers/createInteractiveColorVar/index.js';

const ControlCaretColors = createInteractiveColorVar('controls-caret');
const ControlCaretColorsLightValues = Object.freeze({
    default: '#5A00EE',
    action: '#5A00EE',
    active: '#5A00EE',
    activeAction: '#5A00EE',
});
const ControlCaretColorsDarkValues = Object.freeze({
    default: '#BD99F8',
    action: '#BD99F8',
    active: '#BD99F8',
    activeAction: '#BD99F8',
});

export { ControlCaretColors, ControlCaretColorsDarkValues, ControlCaretColorsLightValues };
